// Add or remove employer follower. ***************************************************************
// pathname: /v1/workplace/{slug}/{status}/follower
// method:   POST
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

/**
 * @description SWR mutation: POST add / remove employer follower. Response status ok: 200.
 * @param slug - string. The employer slug.
 * @param status - 'add' | 'remove'. Specifies whether to add or remove the follower. Accepted values: 'add' or 'remove'.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. An optional callback to call on success.
 * @param successToastText - string. An optional text message to display in the success toast.
 */
export const useSwrWorkplaceToggleFollower = (slug: string, status: 'add' | 'remove', locale: string = 'ro', successCallback?: () => void, successToastText?: string) => {
  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, undefined>({
    url: `/v1/workplace/${slug}/${status}/follower`,
    locale,
    fetcherConfig: {
      method: 'POST',
    },
    apiOptions: {
      onSuccess: () => {
        // Callback
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
